import React, { useState, forwardRef, useEffect } from "react";

import { InputTextarea } from "primereact/inputtextarea";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import studentsAPI from "../../../../services/students";

const UpdateRegistrationDroppoutDetailsModal = forwardRef((props, ref) => {
  //
  const [details, setDetails] = useState("");
  //
  useEffect(() => {
    setDetails(props?.student?.unregistration_reason);
  }, [props]);

  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Détails sur la demande de désinscription"
        serviceAPI={studentsAPI}
        id={props?.student?.id}
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        data={{
          unregistration_reason: details,
        }}
      >
        <InputTextarea value={details || ""} className="w-full" onChange={(e) => {
          setDetails(e.target.value);
        }} rows={5} autoResize />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateRegistrationDroppoutDetailsModal;
